module.exports = __webpack_public_path__ + "img/rubon78.bfe0da58.jpg";